import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import BrandLogo from "./brandLogo";

import {
  acaia,
  aeropress,
  asobu,
  cafetto,
  chemex,
  dualit,
  ecoLife,
  fellow,
  gat,
  hario,
  ivykin,
  kaffeeForm,
  marco,
  melitta,
  origami,
  outIn,
  pallo,
  specialtyCoffee,
  toddy,
  topMoka,
} from "../../../../assets/brands/brandLogoImages";

const scrollX = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

export default function BrandLogosMarquee({ gap = 16, duration = 50 }) {
  const logos = [
    { src: acaia, alt: "Acaia" },
    { src: aeropress, alt: "Aeropress" },
    { src: asobu, alt: "Asobu" },
    { src: cafetto, alt: "Cafetto" },
    { src: chemex, alt: "Chemex" },
    { src: dualit, alt: "Dualit" },
    { src: ecoLife, alt: "EcoLife" },
    { src: fellow, alt: "Fellow" },
    { src: gat, alt: "GAT" },
    { src: hario, alt: "Hario" },
    { src: ivykin, alt: "Ivykin" },
    { src: kaffeeForm, alt: "KaffeeForm" },
    { src: marco, alt: "Marco" },
    { src: melitta, alt: "Melitta" },
    { src: origami, alt: "Origami" },
    { src: outIn, alt: "OutIn" },
    { src: pallo, alt: "Pallo" },
    { src: specialtyCoffee, alt: "Specialty Coffee" },
    { src: toddy, alt: "Toddy" },
    { src: topMoka, alt: "Top Moka" },
  ];

  const doubled = [...logos, ...logos];

  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        height: 50,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        maxWidth: "1440px",
        "&::before, &::after": {
          content: '""',
          position: "absolute",
          top: 0,
          bottom: 0,
          width: 100,
          zIndex: 2,
          pointerEvents: "none",
        },
      })}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap,
          minWidth: "200%",
          animation: `${scrollX} ${duration}s linear infinite`,
          py: 1,
          px: 2,
        }}
      >
        {doubled.map(({ src, alt }, i) => (
          <BrandLogo key={`${i}-${alt}`} src={src} alt={alt} />
        ))}
      </Box>
    </Box>
  );
}
